import Checkbox from "@mui/material/Checkbox";
import { Doctor } from "../../models";

interface LinkedBpDoctorsProps {
	doctor: Doctor | null;
	onUnlink: (id: number) => void;
	onToggle: (
		type:
			| "FaceToFace"
			| "Telehealth"
			| "LocalTelehealth"
			| "TakingAppointments",
		id: number
	) => void;
	errors: number[];
}
export const LinkedBpDoctors = ({
	doctor,
	onUnlink,
	onToggle,
	errors
}: LinkedBpDoctorsProps) => {
	if (!doctor) return null;

	const list = doctor.bpDoctors || [];

	return (
		<>
			<div className="ch-m-text ch-em-text">Linked Best Practice Doctors</div>
			{list.length === 0 && <div className="py-4">No BP Doctors linked</div>}

			<table className="ch-table" style={{ minWidth: "1000px" }}>
				<thead>
					<tr>
						<th>Salutation</th>
						<th>Display Name</th>
						<th>Centre</th>
						<th>Face to face</th>
						<th>Telehealth</th>
						<th>Local Telehealth</th>
						<th>Appointments</th>
						<th style={{ textAlign: "center" }}>Remove</th>
					</tr>
				</thead>
				<tbody>
					{list.map((doctor) => (
						<tr
							key={doctor.id}
							className={errors.includes(doctor.id) ? "emergency" : ""}
						>
							<td>{doctor.salutation}</td>
							<td>{doctor.fullName}</td>
							<td>{doctor.clinicName}</td>
							<td>
								<Checkbox
									value={doctor.id}
									checked={doctor.takingFaceToFace}
									onChange={() => onToggle("FaceToFace", doctor.id)}
								/>
							</td>
							<td>
								<Checkbox
									value={doctor.id}
									checked={doctor.takingTelehealth}
									onChange={() => onToggle("Telehealth", doctor.id)}
								/>
							</td>
							<td>
								<Checkbox
									value={doctor.id}
									checked={doctor.takingLocalTelehealth}
									onChange={() => onToggle("LocalTelehealth", doctor.id)}
								/>
							</td>
							<td>
								<Checkbox
									value={doctor.id}
									checked={doctor.takingAppointments}
									onChange={() => onToggle("TakingAppointments", doctor.id)}
								/>
							</td>

							<td className="text-center">
								<button
									className="ch-button-clear"
									onClick={() => onUnlink(doctor.id)}
								>
									<img
										src="images/svg/delete-blue-outline.svg"
										alt="remove"
										width="28"
										height="28"
									/>
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
};
